import { jsx as _jsx } from "react/jsx-runtime";
import { AfyButton } from "@affinitysystemsgroup/assurehub-ui";
import { REJECTION_CODES_TEXT } from "../../../../../constants/rejectionCodes.constants";
import { RejectionCodeFieldsRow } from "../../../../rejectionCodeFieldsRow";
import { useDraftCodeForm } from "../hook/draftCodeForm.hook";
import { DraftCodeFormRow } from "../style/draftCodeForm.style";
export var DraftCodeFormView = function (props) {
    var p = useDraftCodeForm(props);
    return (_jsx(DraftCodeFormRow, { children: _jsx(RejectionCodeFieldsRow, { control: p.control, compact: true, trailing: _jsx(AfyButton, { label: REJECTION_CODES_TEXT.addCodeButton, type: "button", onClick: p.onSubmit, variant: "filled", color: "brand", size: "sm" }) }) }));
};
